import { render, staticRenderFns } from "./SubjectFrm.vue?vue&type=template&id=3bc8f0cc&"
import script from "./SubjectFrm.vue?vue&type=script&lang=js&"
export * from "./SubjectFrm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports